<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">
                <b-form-row @keyup.enter="loadData">
                    <b-col cols="12" class="text-left">
                        <lg-form-const-select label="Sistema:*" v-model="form.sistema" :options="optionsSistemas"
                            @change="onChangeSistema" />
                    </b-col>
                    <b-col cols="12" class="text-left">
                        <lg-form-const-select label="Perfil:*" v-model="form.perfil" :options="optionsPerfis"
                            @change="onChangePerfil" />
                    </b-col>
                    <b-col lg="12" class="text-left">
                        <lg-form-const-select label="Módulo:*" v-model="form.modulo" :options="optionsModulos"
                            @change="onChangeModulo" />
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col lg="6" sm="12" class="text-left">
                        <b-table responsive class="mt-2" small :busy="busyEntidades" :items="entidades"
                            :fields="entityFields" hover show-empty @row-clicked="onEntidadeClicked">
                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>
                            <template #cell(status)="row">
                                <div :id="row.index + 'statusEntidade'">
                                    <b-icon :icon="iconeEntidade(row.item)" variant="success"></b-icon>
                                </div>
                            </template>
                        </b-table>
                    </b-col>

                    <b-col lg="6" sm="12" class="text-left">
                        <b-table responsive class="mt-2" small :busy="busyMenus" :items="menus" :fields="menuFields"
                            hover show-empty>
                            <template #empty>
                                <p>Nenhum registro encontrado</p>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-primary my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                </div>
                            </template>

                            <template #cell(selecionado)="row">
                                <b-form-checkbox :id="row.index + 'menuCheckbox'" v-model="row.item.selecionado"
                                    @change="onMenuCheckChange(row.item)" switch size="lg" :value="true"
                                    :unchecked-value="false" />
                                <b-tooltip :target="row.index + 'menuCheckbox'"
                                    title="Ativar/Desativar acesso"></b-tooltip>
                            </template>

                            <template #cell(privilegio)="row">
                                <span>{{ getMenuLabel(row.item) }}</span>
                            </template>

                            <template #head(selecionado)>
                                <b-form-checkbox v-b-tooltip.hover.left="'Selecionar/Deselecionar todos'"
                                    id="checkboxSelecionarTodos" :disabled="!menus || menus.length == 0"
                                    v-model="selecionarTodos" @change="onSelecionarTodosChange" switch size="lg"
                                    :value="true" :unchecked-value="false" />
                            </template>
                        </b-table>
                    </b-col>
                </b-form-row>

                <b-form-row @keyup.enter="onSalvar">
                    <b-col cols="12" class="text-center">
                        <b-button id="btnSalvar" class=" my-2" size="sm" pill variant="success" @click="onSalvar">
                            <b-icon icon="check-circle" />
                            <b-tooltip target="btnSalvar" title="Salvar"></b-tooltip>

                        </b-button>

                    </b-col>
                </b-form-row>
            </b-card>
        </b-card-body>
    </b-card>
</template>

<script>
import {
    BFormCheckbox,
    BCard,
    BFormRow,
    BCol,
    BButton,
    BTooltip,
    BIcon,
    BSpinner,
    BTable
} from 'bootstrap-vue';

import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import PerfilMenuService from "@/core/api/PerfilMenuService";

export default {
    name: "SguPerfilUsuarioList",
    components: {
        LgFormConstSelect,
        BFormCheckbox,
        BCard,
        BFormRow,
        BCol,
        BButton,
        BTooltip,
        BIcon,
        BSpinner,
        BTable
    },

    data() {
        return {
            busyEntidades: false,
            busyMenus: false,
            page: 1,
            perPage: 10,
            total: 0,
            perPageOptions: [10, 25, 50, 100],

            form: {
                sistema: null,
                perfil: null,
                modulo: null,
                situacao: 1
            },
            selecionarTodos: false,

            entidades: [],
            menus: [],

            optionsSistemas: [],
            optionsPerfis: [],
            optionsModulos: [],

            entityFields: [
                {
                    key: 'status',
                    label: ' ',
                    thStyle: 'width:40px; text-align:center;',
                    tdStyle: 'text-align:center;'
                },
                {
                    key: 'descEntidade',
                    label: 'Entidade'
                }
            ],
            menuFields: [
                {
                    key: 'selecionado',
                    label: ' ',
                    thStyle: 'width:25px; text-align:center;',
                    tdStyle: 'text-align:center;'
                },
                {
                    key: 'privilegio',
                    label: 'Privilégio',
                    thStyle: 'width:235px;'
                }
            ],

            listaSalvar: [],
            listaRemover: []
        };
    },
    mounted() {
        this.loadSistemas();
    },
    methods: {

        iconeEntidade(entidade) {
            var quantidade = 0;

            entidade.menus.forEach(m => {
                if (m.selecionado)
                    ++quantidade;
            });



            if (quantidade == 0)
                return "journal";

            if (quantidade == entidade.menus.length)
                return "journal-text";

            return "journal-minus";


        },


        async loadSistemas() {
            try {
                const { data } = await PerfilMenuService.listSistema({
                    situacao: 1,
                    indiceInicio: 0,
                    numItens: 5
                });

                this.optionsSistemas = [
                    { text: 'Selecione...', value: null },
                    ...data.sistemas.map(s => ({
                        text: s.nome,
                        value: s.id
                    }))
                ];
            } catch (error) {
                console.error("Erro ao carregar sistemas:", error);
            }
        },

        onChangeSistema() {
            this.form.perfil = null;
            this.form.modulo = null;
            this.entidades = [];
            this.menus = [];
            this.loadPerfis();
        },

        async loadPerfis() {
            if (!this.form.sistema) {
                this.optionsPerfis = [{ text: 'Selecione...', value: null }];
                return;
            }
            try {
                const { data } = await PerfilMenuService.listPerfil({
                    codSistema: this.form.sistema,
                    situacao: 1
                });
                this.optionsPerfis = [
                    { text: 'Selecione...', value: null },
                    ...data.map(p => ({
                        text: p.perfil,
                        value: p.id
                    }))
                ];
            } catch (error) {
                console.error("Erro ao carregar perfis:", error);
            }
        },

        onChangePerfil() {
            this.form.modulo = null;
            this.entidades = [];
            this.menus = [];
            this.loadModulos();
        },

        async loadModulos() {
            if (!this.form.perfil) {
                this.optionsModulos = [{ text: 'Selecione...', value: null }];
                return;
            }
            const { data } = await PerfilMenuService.listModuloSistema({
                codSistema: this.form.sistema,
                situacao: 1
            });
            this.optionsModulos = [
                { text: 'Selecione...', value: null },
                ...data.map(m => ({
                    text: m.descricao,
                    value: m.id
                })),
                { text: 'Outros', value: -1 }
            ];
        },

        onChangeModulo() {
            this.entidades = [];
            this.menus = [];
            this.loadData();
        },

        async loadData() {
            if (!this.form.sistema || !this.form.perfil || !this.form.modulo) {
                return;
            }
            this.busyEntidades = true;
            const { data } = await PerfilMenuService.listEntidade({
                codSistema: this.form.sistema,
                codModulo: this.form.modulo,
                codPerfil: this.form.perfil,
                situacao: 1
            });
            this.entidades = data.map(e => ({
                menus: e.menus,
                codEntidade: e.id,
                nomeEntidade: e.nome,
                descEntidade: e.descricao,
                qntMenu: 0,
                qntMenuSelecionado: 0
            }));
            this.total = this.entidades.length;
            this.busyEntidades = false;
        },

        async onEntidadeClicked(item) {
            this.todosSelecionados = false;
            this.busyMenus = true;
            this.menus = [];

            this.menus = item.menus.map(m => ({
                codMenu: m.id,
                nomeMenu: m.nome,
                descControleMenu: m.descricaoControle || '',
                selecionado: m.selecionado
            }));

            this.busyMenus = false;

            var todosSelecionados = true;
            this.menus.forEach(m => {

                var index = this.listaSalvar.findIndex(menu => menu.codMenu == m.codMenu);
                if (index !== -1)
                    m.selecionado = true
                else {
                    index = this.listaRemover.findIndex(menu => menu.codMenu == m.codMenu);
                    if (index !== -1)
                        m.selecionado = false
                }

                if (!m.selecionado)
                    todosSelecionados = false;
            });

            this.selecionarTodos = todosSelecionados;

        },

        onMenuCheckChange(menu) {


            if (menu.selecionado) {
                const idxRemove = this.listaRemover.findIndex(
                    pm => pm.codMenu === menu.codMenu && pm.codPerfil === this.form.perfil
                );
                if (idxRemove !== -1) {
                    this.listaRemover.splice(idxRemove, 1);
                } else {
                    const exists = this.listaSalvar.some(
                        pm => pm.codMenu === menu.codMenu && pm.codPerfil === this.form.perfil
                    );
                    if (!exists) {
                        this.listaSalvar.push({
                            codPerfil: this.form.perfil,
                            codMenu: menu.codMenu
                        });
                    }
                }
            } else {
                const idxSave = this.listaSalvar.findIndex(
                    pm => pm.codMenu === menu.codMenu && pm.codPerfil === this.form.perfil
                );
                if (idxSave !== -1) {
                    this.listaSalvar.splice(idxSave, 1);
                } else {
                    const exists = this.listaRemover.some(
                        pm => pm.codMenu === menu.codMenu && pm.codPerfil === this.form.perfil
                    );
                    if (!exists) {
                        this.listaRemover.push({
                            codPerfil: this.form.perfil,
                            codMenu: menu.codMenu
                        });
                    }
                }


            }

            var todosSelecionados = true;

            this.menus.forEach(m => {
                if (!m.selecionado)
                    todosSelecionados = false;
            });

            this.selecionarTodos = todosSelecionados;

        },

        onSelecionarTodosChange(seleciona) {
            this.menus.forEach(m => {
                m.selecionado = seleciona;
                this.onMenuCheckChange(m);
            });
        },

        getMenuLabel(menu) {
            if (menu.descControleMenu && menu.descControleMenu !== "") {
                return menu.descControleMenu;
            } else {
                return menu.nomeMenu;
            }
        },

        onSalvar() {
            const payload = {
                listaSalvar: this.listaSalvar,
                listaRemover: this.listaRemover
            };
            this.busy = true;

            PerfilMenuService.salvarPerfilMenu(
                {
                    codSistema: this.form.sistema,
                    codPerfil: this.form.perfil
                },
                payload
            )
                .then(() => {
                    this.$bvToast.toast("Alterações salvas com sucesso!", {
                        title: "Sucesso",
                        variant: "success",
                        solid: true
                    });

                    this.listaSalvar = [];
                    this.listaRemover = [];
                    this.menus = [];

                    this.loadData();
                })
                .catch(error => {
                    this.$bvToast.toast(error.response.data, {
                        title: "Erro",
                        variant: "danger",
                        solid: true
                    });
                });
        },

        onCancelar() {
            this.$emit("close");
        }
    }
};
</script>

<style scoped>
.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
